/* istanbul ignore file */
import axios from 'axios';
import { getApiBaseUrl } from 'helpers/api';

const baseUrl = getApiBaseUrl();
const TIME_OUT = 30000;

const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: TIME_OUT,
  headers: {
    contentType: 'application/json',
    accept: 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.token) {
      const token = localStorage.getItem('token');

      if (token) {
        config.headers.Authorization = token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 498) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
